import { render } from "./RecipeDetails.vue?vue&type=template&id=1211f762"
import script from "./RecipeDetails.vue?vue&type=script&lang=js"
export * from "./RecipeDetails.vue?vue&type=script&lang=js"

import "./smartrecipeDetails.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__